import JsonManager from './JsonManager';

class HeaderManager {
  constructor() {
    this.header = JsonManager.getHeader();
  }

  getMenu() {
    return this.header.menu;
  }
}

export default HeaderManager;



// WEBPACK FOOTER //
// ./src/managers/HeaderManager.js